 
import JobBreadcrumb from "../../commonComponents/breadcrumbs/JobBreadcrumb";
import JobDetail from "../../commonComponents/productDetail/JobDetail";

const JobDetail4Container = () => {
  return (
    <>
      <JobBreadcrumb type="style_4" />
      <JobDetail detailType="style_4" />
    </>
  );
};

export default JobDetail4Container;
